export const contentProductDetail = {
	fieldName: {
		image: "Imagen",
		name: "Nombre",
		productType: "Tipo del producto",
		unitOfMeasurement: "Inventario controlado por",
		category: "Categoría",
		menuCategory: "Categoría del menú",
		price: "Precio",
		description: "Descripción",
		drinkStyle: "Estilo de la bebida",
		alcoholContent: "ABV - Contenido alcohólico",
		hasAlcohol: "Contiene alcohol",
		hiddenZigApp: "No mostrar el producto en ZigApp",
		sincMyTapp: "Sincronizar con MyTapp",
		productReturn: "Producto retornable",
		brand: "Marca",
		variableValue: "Precio variable",
		stockableProduct: "Producto almacenable",
		preparationTime: "Tiempo de preparación",
		preparationTimePlaceholder: "30",
		preparationTimeUnit: "minutos",
	},
	requiredField: "Campo obligatorio",
	editImage: "Haga clic en la imagen para editar",
	preparationTimeMustBeGreaterThanZero: "El tiempo de preparación debe ser mayor que 0",
};
